export const GET_MODELS_REQUEST = "GET_MODELS_REQUEST";
export const GET_MODELS_SUCCESS = "GET_MODELS_SUCCESS";
export const GET_MODELS_FAILURE = "GET_MODELS_FAILURE";